// extracted by mini-css-extract-plugin
export default {"tag":"permission-override-badge_tag__MBz+A","content":"permission-override-badge_content__DOTBh","list":"permission-override-badge_list__X+11A"};